import { ChevronRightIcon } from '@heroicons/react/outline';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React from 'react';

import ButtonDefault, { ButtonVariants } from '../../shared/basic/button';

const IntoSectionProjects = () => {
  const screens = useBreakpoint();
  return (
    <>
      <div className='md:flex w-full py-10 px-5 xl:p-24'>
        <div className='w-full flex  items-center   text-center'>
          <div className='flex justify-start  w-full text-fadedWhite'>
            <div className=' flex flex-col gap-y-4 '>
              <div className='py-2 px-4 rounded-lg border border-[#1C1C1C] w-fit mb-1'>
                Add Products
              </div>

              <span className='text-xl xxxs:text-2xl lg:text-5xl  text-start   h-full font-bold'>
                Book, Courses & Bundles
              </span>
              <span className='flex flex-col gap-y-2 text-sm  xl:text-base text-[#C7C6CF] text-start '>
                Experience the Books of Next Generation Zebralearn Books - Your
                Competitive Edge!
              </span>
              <span className='md:w-1/2 mt-4'>
                <ButtonDefault
                  size={screens.md ? 4 : 1}
                  variant={ButtonVariants.PRIMARY}
                  className='w-fit md:w-full'
                  rounded={false}
                  roundedSm={true}
                  enableScaling={false}
                  onClick={() => {
                    if (window !== undefined) {
                      window.open(
                        'https://business.zebralearn.com/business ',
                        '_blank',
                      );
                    }
                  }}
                >
                  <span className='flex text-sm md:text-base font-semibold gap-x-2 items-center md:px-2  whitespace-nowrap'>
                    Explore Business for Bulk order{' '}
                    <ChevronRightIcon className='w-4 h-4' />
                  </span>
                </ButtonDefault>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntoSectionProjects;
